import { render, staticRenderFns } from "./FilterBarProviderMulti.vue?vue&type=template&id=53270dc8&scoped=true"
import script from "./FilterBarProviderMulti.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarProviderMulti.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarProviderMulti.vue?vue&type=style&index=0&id=53270dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53270dc8",
  null
  
)

export default component.exports